/* Copyright (c) 2020-2026 Nordcloud Oy or its affiliates. All Rights Reserved. */

import {
  useGetRoleBindingsByUsersQuery,
  RoleBindingsByUsersSortInput,
} from "~/generated/graphql";

type Props = {
  page: string;
  limit: string;
  sort: RoleBindingsByUsersSortInput;
};

export function useGetRoleBindingsByUsers({ page, limit, sort }: Props) {
  const { data, loading, error, refetch } = useGetRoleBindingsByUsersQuery({
    variables: { page: Number(page), limit: Number(limit), sort },
    notifyOnNetworkStatusChange: true,
  });

  const count = data?.roleBindingsByUsers?.pageInfo?.count ?? 0;

  return {
    data: data?.roleBindingsByUsers?.result ?? [],
    loading,
    error,
    count,
    refetch,
  } as const;
}
